/* TYMWORK - tarjetero, testimonios, marquesinas, carruseles, filtros, acordeon, galeria */
(function () {
  'use strict';
  if (window.__twAnim2) return; window.__twAnim2 = 1;

  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var onScroll = function (fn) {
    if (window.twOnScroll) return window.twOnScroll(fn);
    document.addEventListener('scroll', fn, { passive: true, capture: true });
    window.addEventListener('resize', fn);
  };

  /* TARJETERO: capas que suben + tarjetas que se apilan */
  function initScroll() {
    $$('.tw-scroll').forEach(function (wrap) {
      if (wrap.dataset.on) return; wrap.dataset.on = '1';
      var layers = $$('.tw-layer', wrap);
      var cards = $$('.tw-slot .tw-prod', wrap);
      var steps = Math.max(layers.length, cards.length) - 1;
      if (steps < 1) return;
      var pin = $('.tw-scroll__pin', wrap);
      var dots = document.createElement('div'); dots.className = 'tw-dots';
      for (var d = 0; d <= steps; d++) dots.appendChild(document.createElement('i'));
      if (pin) pin.appendChild(dots);
      var bars = $$('i', dots);
      var HOLD_IN = 0.10, HOLD_OUT = 0.08, TRAVEL = 0.74;
      function smooth(t) { return t * t * (3 - 2 * t); }
      function tick() {
        var total = wrap.offsetHeight - window.innerHeight;
        if (total <= 0) return;
        var p = Math.max(0, Math.min(1, -wrap.getBoundingClientRect().top / total));
        var seg = (1 - HOLD_IN - HOLD_OUT) / steps;
        for (var k = 0; k < steps; k++) {
          var local = Math.max(0, Math.min(1, (p - (HOLD_IN + k * seg)) / (seg * TRAVEL)));
          var e = smooth(local), off = (1 - e) * 100, i = k + 1;
          if (layers[i]) layers[i].style.transform = 'translate3d(0,' + off + '%,0)';
          if (cards[i]) {
            cards[i].style.transform = 'translate3d(0,' + off + '%,0)';
            cards[i].style.zIndex = local > 0 ? (10 + i) : (10 - i);
          }
          if (bars[i]) bars[i].style.setProperty('--f', e);
        }
        if (bars[0]) bars[0].style.setProperty('--f', 1);
      }
      tick(); onScroll(tick);
    });
  }

  /* TESTIMONIOS: carril horizontal movido por el scroll */
  function initTesti() {
    $$('.tw-testi').forEach(function (wrap) {
      if (wrap.dataset.on) return; wrap.dataset.on = '1';
      var track = $('.tw-testi__t', wrap); if (!track) return;
      function tick() {
        var total = wrap.offsetHeight - window.innerHeight;
        if (total <= 0) return;
        var p = Math.max(0, Math.min(1, -wrap.getBoundingClientRect().top / total));
        var dist = track.scrollWidth - window.innerWidth + 40;
        track.style.transform = 'translate3d(' + (-p * Math.max(0, dist)) + 'px,0,0)';
      }
      tick(); onScroll(tick);
    });
  }

  function initMq() {
    $$('.tw-mq').forEach(function (m) {
      var t = $('.tw-mq__t', m);
      if (!t || t.dataset.cloned) return;
      t.dataset.cloned = '1';
      var c = t.cloneNode(true); c.setAttribute('aria-hidden', 'true'); m.appendChild(c);
    });
  }

  function initSliders() {
    $$('.tw-slider').forEach(function (sl) {
      if (sl.dataset.on) return; sl.dataset.on = '1';
      var track = $('.tw-slider__t', sl);
      var slides = $$('.tw-slide', track);
      var root = sl.closest('[data-tw-slider-scope]') || sl.parentNode;
      var prev = $('[data-tw-prev]', root), next = $('[data-tw-next]', root);
      var index = 0;
      function per() {
        if (sl.classList.contains('tw-slider--1')) return 1;
        return innerWidth < 640 ? 1 : innerWidth < 992 ? 2 : 3;
      }
      function max() { return Math.max(0, slides.length - per()); }
      function go(i) {
        index = Math.max(0, Math.min(max(), i));
        var gap = parseFloat(getComputedStyle(track).gap) || 0;
        var w = slides.length ? slides[0].getBoundingClientRect().width + gap : 0;
        track.style.transform = 'translate3d(' + (-index * w) + 'px,0,0)';
        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index === max();
      }
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      var down = false, sx = 0, moved = 0;
      sl.addEventListener('pointerdown', function (e) { down = true; sx = e.clientX; moved = 0; });
      window.addEventListener('pointerup', function () {
        if (!down) return; down = false;
        if (Math.abs(moved) > 60) go(index + (moved < 0 ? 1 : -1));
      });
      window.addEventListener('pointermove', function (e) { if (down) moved = e.clientX - sx; });
      window.addEventListener('resize', function () { go(index); });
      go(0);
    });
  }

  /* FILTROS por etiqueta.
     data-tw-max en la rejilla = cuantos productos se muestran POR categoria (0 = todos).
     La rejilla trae TODOS los productos de la coleccion; aqui se decide cuales se ven. */
  function initFiltros() {
    $$('[data-tw-filtros]').forEach(function (g) {
      if (g.dataset.on) return; g.dataset.on = '1';
      var target = document.querySelector(g.dataset.twFiltros);
      if (!target) return;
      var items = $$('[data-tw-cat]', target);
      var max = parseInt(target.getAttribute('data-tw-max') || '0', 10) || 0;

      function apply(v, animar) {
        var vistos = 0;
        items.forEach(function (it, i) {
          var coincide = v === 'all' || (' ' + it.dataset.twCat + ' ').indexOf(' ' + v + ' ') > -1;
          var show = coincide && (max === 0 || vistos < max);
          if (show) vistos++;
          if (!animar) {
            it.style.display = show ? '' : 'none';
            return;
          }
          it.style.transition = 'opacity .45s ease, transform .55s ease';
          it.style.transitionDelay = (i % 6) * 45 + 'ms';
          if (show) {
            it.style.display = '';
            requestAnimationFrame(function () { it.style.opacity = 1; it.style.transform = 'none'; });
          } else {
            it.style.opacity = 0; it.style.transform = 'scale(.94)';
            setTimeout(function () { it.style.display = 'none'; }, 300);
          }
        });
      }

      apply('all', false);

      $$('.tw-pill', g).forEach(function (btn) {
        btn.addEventListener('click', function () {
          $$('.tw-pill', g).forEach(function (b) { b.classList.remove('is-on'); });
          btn.classList.add('is-on');
          apply(btn.dataset.val, true);
        });
      });
    });
  }

  function initAcc() {
    $$('.tw-acc__i').forEach(function (item) {
      if (item.dataset.on) return; item.dataset.on = '1';
      var btn = $('.tw-acc__b', item), panel = $('.tw-acc__p', item);
      if (!btn || !panel) return;
      if (item.classList.contains('is-open')) panel.style.height = panel.scrollHeight + 'px';
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        panel.style.height = open ? panel.scrollHeight + 'px' : '0px';
      });
    });
  }

  function initGaleria() {
    $$('.tw-pdp__thumbs').forEach(function (wrap) {
      if (wrap.dataset.on) return; wrap.dataset.on = '1';
      var pdp = wrap.closest('.tw-pdp') || document;
      var main = $('.tw-pdp__main img', pdp);
      $$('.tw-pdp__thumb', wrap).forEach(function (t) {
        t.addEventListener('click', function () {
          $$('.tw-pdp__thumb', wrap).forEach(function (x) { x.classList.remove('is-on'); });
          t.classList.add('is-on');
          var src = t.dataset.full; if (main && src) { main.srcset = ''; main.src = src; }
        });
      });
    });
  }

  /* botones con iman */
  function initIman() {
    if (window.matchMedia('(hover: none)').matches) return;
    $$('.tw-btn').forEach(function (el) {
      if (el.dataset.iman) return; el.dataset.iman = '1';
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * 0.22) + 'px,' +
                             ((e.clientY - r.top - r.height / 2) * 0.22) + 'px)';
      });
      el.addEventListener('pointerleave', function () {
        el.style.transition = 'transform .6s cubic-bezier(.22,1,.36,1)';
        el.style.transform = '';
        setTimeout(function () { el.style.transition = ''; }, 620);
      });
    });
  }

  function all() {
    initScroll(); initTesti(); initMq(); initSliders();
    initFiltros(); initAcc(); initGaleria(); initIman();
  }
  function boot() {
    all();
    window.addEventListener('load', all);
    setTimeout(all, 700);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', all);
})();
